import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="loadingio-spinner-cube-xm7stm3s6t">
      <div class="ldio-12q48m8lyyeq">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <style type="text/css">
      @keyframes ldio-12q48m8lyyeq {
        0% {
          transform: scale(1.1500000000000001);
        }
        100% {
          transform: scale(1);
        }
      }
      .ldio-12q48m8lyyeq div {
        position: absolute;
        width: 80px;
        height: 80px;
        top: 13.333333333333336px;
        left: 13.333333333333336px;
        background: #e15b64;
        animation: ldio-12q48m8lyyeq 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
        animation-delay: -0.3s;
      }
      .ldio-12q48m8lyyeq div:nth-child(2) {
        top: 13.333333333333336px;
        left: 106.66666666666666px;
        background: #f47e60;
        animation-delay: -0.2s;
      }
      .ldio-12q48m8lyyeq div:nth-child(3) {
        top: 106.66666666666666px;
        left: 13.333333333333336px;
        background: #abbd81;
        animation-delay: 0s;
      }
      .ldio-12q48m8lyyeq div:nth-child(4) {
        top: 106.66666666666666px;
        left: 106.66666666666666px;
        background: #f8b26a;
        animation-delay: -0.1s;
      }
      .loadingio-spinner-cube-xm7stm3s6t {
        width: 200px;
        height: 200px;
        display: inline-block;
        overflow: hidden;
        background: transparent;
      }
      .ldio-12q48m8lyyeq {
        width: 100%;
        height: 100%;
        position: relative;
        transform: translateZ(0) scale(1);
        backface-visibility: hidden;
        transform-origin: 0 0; /* see note above */
      }
      .ldio-12q48m8lyyeq div {
        box-sizing: content-box;
      }
      /* generated by https://loading.io/ */
    </style>
  `,
  styles: [],
})
export class SpinnerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
